module.exports = __webpack_public_path__ + "img/MarcErdmann_140x140_rund.c0b2c45d.jpg";